import { Dispatcher } from '@nu-art/ts-common';
export const dispatcher_onAuthRequired = new Dispatcher('__onAuthRequiredListener');
//# sourceMappingURL=no-auth-listener.js.map